import React from "react";
import "../styles/components/programmation-calendar.scss";
import "../styles/page-programmation.scss";
import Navigation from "../components/Navigation";
import EVENTS from "../data/programmation-weekend";
import CalendrierProg from "../components/Calendrier-prog";

export default function Programmation() {
  return (
    <div className="page-programmation">
      <Navigation />

      <main className="container">
        <section className="programmation-content pt-2 mb-3">
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12">
              <div className="contenu text-center">
                <CalendrierProg events={EVENTS} />
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}